// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class SearchArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.SearchArgs';
  $t: string = 'SagaBase.Defines.SearchArgs';

  public static GetMembers(): string[] {
    return ['ExternalUid', 'SiteId', 'Logging', 'OverrideTypeToRead', 'ID', 'MaxCount', 'Param1', 'Param2', 'Param3'];
  }

  public GetMembers(): string[] {
    return SearchArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ExternalUid: string = '';
  public SiteId: number = -1;
  public Logging: boolean = true;
  public OverrideTypeToRead: string;
  public ID: number = 0;
  public MaxCount: number = 0;
  public Param1: any;
  public Param2: any;
  public Param3: any;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.ID;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
